import { UserSession } from '../common/interfaces/auth';

export const getUserSession = () => {
  const userSession: UserSession = JSON.parse(localStorage.getItem('user') || '{}');
  return userSession;
};
